export default __webpack_public_path__ + "static/media/seLoger.937e6c00.svg";